const actions = {
  // Estadísticas de Ventas
  GET_ESTADISTICAS_VENTAS: 'GET_ESTADISTICAS_VENTAS',
  GET_ESTADISTICAS_VENTAS_SUCCESS: 'GET_ESTADISTICAS_VENTAS_SUCCESS',
  GET_ESTADISTICAS_VENTAS_ERROR: 'GET_ESTADISTICAS_VENTAS_ERROR',
  
  // Estadísticas de Ingresos
  GET_ESTADISTICAS_INGRESOS: 'GET_ESTADISTICAS_INGRESOS',
  GET_ESTADISTICAS_INGRESOS_SUCCESS: 'GET_ESTADISTICAS_INGRESOS_SUCCESS',
  GET_ESTADISTICAS_INGRESOS_ERROR: 'GET_ESTADISTICAS_INGRESOS_ERROR',
  
  // Estadísticas de Egresos
  GET_ESTADISTICAS_EGRESOS: 'GET_ESTADISTICAS_EGRESOS',
  GET_ESTADISTICAS_EGRESOS_SUCCESS: 'GET_ESTADISTICAS_EGRESOS_SUCCESS',
  GET_ESTADISTICAS_EGRESOS_ERROR: 'GET_ESTADISTICAS_EGRESOS_ERROR',
  
  // Reset
  RESET_ESTADISTICAS: 'RESET_ESTADISTICAS',
  
  // Action Creators - Estadísticas de Ventas
  getEstadisticasVentas: (params) => ({
    type: actions.GET_ESTADISTICAS_VENTAS,
    payload: params, // { inicio, fin, periodo }
  }),
  
  getEstadisticasVentasSuccess: (data) => ({
    type: actions.GET_ESTADISTICAS_VENTAS_SUCCESS,
    payload: data,
  }),
  
  getEstadisticasVentasError: (error) => ({
    type: actions.GET_ESTADISTICAS_VENTAS_ERROR,
    payload: error,
  }),
  
  // Action Creators - Estadísticas de Ingresos
  getEstadisticasIngresos: (params) => ({
    type: actions.GET_ESTADISTICAS_INGRESOS,
    payload: params, // { inicio, fin, periodo }
  }),
  
  getEstadisticasIngresosSuccess: (data) => ({
    type: actions.GET_ESTADISTICAS_INGRESOS_SUCCESS,
    payload: data,
  }),
  
  getEstadisticasIngresosError: (error) => ({
    type: actions.GET_ESTADISTICAS_INGRESOS_ERROR,
    payload: error,
  }),
  
  // Action Creators - Estadísticas de Egresos
  getEstadisticasEgresos: (params) => ({
    type: actions.GET_ESTADISTICAS_EGRESOS,
    payload: params, // { inicio, fin, periodo }
  }),
  
  getEstadisticasEgresosSuccess: (data) => ({
    type: actions.GET_ESTADISTICAS_EGRESOS_SUCCESS,
    payload: data,
  }),
  
  getEstadisticasEgresosError: (error) => ({
    type: actions.GET_ESTADISTICAS_EGRESOS_ERROR,
    payload: error,
  }),
  
  // Reset
  resetEstadisticas: () => ({
    type: actions.RESET_ESTADISTICAS,
  }),
};

export default actions;
